import React from 'react';
import './_commonjsHelpers-df867233.js';
import { P as PropTypes } from './index-6a8f8095.js';
import styled, { css } from 'styled-components';
import { _ as _taggedTemplateLiteral, a as _objectWithoutProperties, b as _extends } from './_rollupPluginBabelHelpers-b3c9b1cd.js';
import './_baseEach-3b97c1a8.js';
import './isArray-a3f14da2.js';
import './_Map-9acd9da3.js';
import './get-f58f8821.js';
import './_baseIteratee-651c88ed.js';
import { r as resetCSS } from './index-7f6959fc.js';
import './head-b3f271d9.js';
import './map-651e82c0.js';
import './join-15b17329.js';
import './noop-d79f8d84.js';
import './isEmpty-9e4c9724.js';
import './wrapMediaQuery-d94fbf55.js';

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var backgroundImage = function backgroundImage(_ref) {
  var bgSrc = _ref.bgSrc;
  return bgSrc ? css(["background-image:url('", "');background-size:'cover';"], bgSrc) : '';
};

var borders = css(["border-radius:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.components.avatar.border.radius;
});
var colors = css(["color:", ";background-color:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.components.avatar.colors.text;
}, function (_ref4) {
  var theme = _ref4.theme,
      bgColor = _ref4.bgColor;
  return theme.colors[bgColor] || bgColor;
});
var fonts = css(["font-family:", ";font-size:", ";line-height:", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.components.avatar.fonts.fontFamily;
}, function (_ref6) {
  var size = _ref6.size,
      theme = _ref6.theme;
  return theme.components.avatar.sizes[size].fontSize;
}, function (_ref7) {
  var size = _ref7.size,
      theme = _ref7.theme;
  return theme.components.avatar.sizes[size].lineHeight;
});
var sizes = css(["width:", ";height:", ";"], function (_ref8) {
  var size = _ref8.size,
      theme = _ref8.theme;
  return theme.components.avatar.sizes[size].size;
}, function (_ref9) {
  var size = _ref9.size,
      theme = _ref9.theme;
  return theme.components.avatar.sizes[size].size;
});
var StyledAvatar = styled('p')(_templateObject(), resetCSS, function (_ref10) {
  var bgSrc = _ref10.bgSrc;
  return backgroundImage({
    bgSrc: bgSrc
  });
}, borders, colors, fonts, sizes);

function _templateObject$1() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
/**
 * Avatar component
 *
 */

var Avatar = function Avatar(_ref) {
  var bgColor = _ref.bgColor,
      bgSrc = _ref.bgSrc,
      children = _ref.children,
      size = _ref.size,
      title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["bgColor", "bgSrc", "children", "size", "title"]);

  return React.createElement(StyledAvatar, _extends({
    bgColor: bgColor,
    bgSrc: bgSrc,
    size: size,
    title: title
  }, rest), children);
};

Avatar.defaultProps = {
  bgColor: '',
  bgSrc: '',
  children: '',
  size: 'medium',
  title: ''
};
Avatar.propTypes = {
  /**
   * The background color of the Avatar. Can be a color value or a color's name from the theme.
   */
  bgColor: PropTypes.string,

  /**
   * Route to the background's picture.
   */
  bgSrc: PropTypes.string,

  /**
   * Content text of the Avatar.
   */
  children: PropTypes.string,

  /**
   * Defines the size of the component.
   */
  size: PropTypes.oneOf(['small', 'medium', 'large']),

  /**
   * Title of the Avatar (useful for accessibility when setting a background image).
   */
  title: PropTypes.string
};
/** @component */

var index = styled(Avatar)(_templateObject$1());

export default index;
